import React from "react";
import Select from "../Select";
import { smartProcessTitlesMatchData } from "../../data/crm_list_data";

const formatElems = code => elem => ({
    value: `${code}_${elem.value}`,
    label: elem.label
});

const CRMField = ({ data, options, value, smartProcessShortCodes, ...props }) => {
    console.log('crm field: debug 1', data, options, smartProcessShortCodes, props);
    const multiList = data.fields.length > 1;
    const formattedOptions = data.fields.map(crmFieldKey => {
        const spObjectWithCode = smartProcessShortCodes.find(({SYMBOL_CODE}) => SYMBOL_CODE === crmFieldKey);
        if (crmFieldKey.startsWith('DYNAMIC')) {
            const currentDynamicList = options.find(({commonType, listId}) => commonType === 'smartProcess' && crmFieldKey === `DYNAMIC_${listId}` );
            if (!multiList) {
                return {label: spObjectWithCode.NAME, options: currentDynamicList.elements.map(elem => ({label: elem.label, value: `${elem.value}`}))};
            }
            return {label: spObjectWithCode.NAME, options: currentDynamicList.elements.map(formatElems(spObjectWithCode.SYMBOL_CODE_SHORT))};
        }
        const currentStandardList = options.find(({commonType, listType}) => commonType === 'common' && listType === smartProcessTitlesMatchData[crmFieldKey]);
        if (!currentStandardList) {
            return [];
        }
        if (!multiList) {
            return {label: spObjectWithCode.NAME, options: currentStandardList.elements};
        }
        return {
            label: spObjectWithCode.NAME,
            options: currentStandardList.elements.map(formatElems(spObjectWithCode.SYMBOL_CODE_SHORT))
        };
    });

    console.log('crm field: debug 2', formattedOptions, smartProcessShortCodes);
    console.log('crm field: debug 3', props.field, value);
    return (
        <div>
            <div>
                <Select {...props} options={formattedOptions} value={value} multiList={true} data={{ multiListsShortCodes: smartProcessShortCodes, lists: data.fields }} />
            </div>
        </div>
    )
};

export default CRMField;